import { FanSpeed3Icon } from './FanSpeed3Icon';

/**
 * author: Michael Irigoyen
 * id 0EA7825B-6236-40D5-A8D9-858B2B4DB595
 * name fan-speed-3
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fan-speed-3.svg
 * tags
 * - Home Automation 
 */
export const FanSpeedHighIcon = FanSpeed3Icon;
export default FanSpeedHighIcon